/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserSearchRequest interface.
 */
export function instanceOfUserSearchRequest(value) {
    return true;
}
export function UserSearchRequestFromJSON(json) {
    return UserSearchRequestFromJSONTyped(json, false);
}
export function UserSearchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nominativo': json['nominativo'] == null ? undefined : json['nominativo'],
        'idPps': json['idPps'] == null ? undefined : json['idPps'],
        'idPpt': json['idPpt'] == null ? undefined : json['idPpt'],
        'attivo': json['attivo'] == null ? undefined : json['attivo'],
    };
}
export function UserSearchRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'nominativo': value['nominativo'],
        'idPps': value['idPps'],
        'idPpt': value['idPpt'],
        'attivo': value['attivo'],
    };
}
